import React, { useState, useEffect } from 'react'
import {
  Input,
  Table,
  Panel,
  PanelGroup,
  Form,
  Message,
  IconButton,
  Icon,
  Uploader,
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  DatePicker,
  RadioGroup,
  Radio,
  Cascader,
  SelectPicker,
  ButtonGroup,
} from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import CustomIconMessageInfo from '../CustomIconMessageInfo'
import { startLoading, doneLoading } from '../../utils/loading'
import CKEditorFrom from '../../components/forms/input/CKEditorFrom'
import {
  getProgessActivity,
  updateProgessActualActivity,
  saveProgessActivity,
  updateProgessActivity,
} from '../../redux/actions/projectProgress'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SaveButton from '../../components/buttons/saveButton/SaveButton'
import EditButton from '../../components/buttons/editButton/EditButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { isRequired, isValidators, isRequiredFiled } from '../../utils/ValidatorUtils'
import moment from 'moment'
import GMap from '../../components/map/GMap'
import classNames from 'classnames'
import { getLocation } from '../../redux/actions/location'
import { getValueFromOptions } from '../../utils/dataUtil'
import { fromPairs } from 'lodash'
import { loadLocation } from '../../components/location/Location'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'

export default function AreaTableForm({ schema: _formSchemas, ...props }) {
  const { showCommandButton, isEditAll, editData, isDep6 } = props
  const { Column, HeaderCell, Cell } = Table

  const [isEdit, setIsEdit] = useState(false)
  const [isError, setIsError] = useState(false)
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, getValues, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_formSchemas)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const [valueID, setValueID] = useState('')
  const [isAdd, setIsAdd] = useState(false)
  const [activity, setActivity] = useState('')
  const [activityDetail, setActivityDetail] = useState('')
  const [underPurpose, setUnderPurpose] = useState()
  const [editIndex, setEditIndex] = useState(-1)
  const [isDeleteFail, setIsDeleteFail] = useState(false)
  const [isSaveError, setIsSaveError] = useState(false)

  const [progressId, setProgressId] = useState()

  const [locationList, setLocationList] = useState([])
  const [markers, setMarkers] = useState([])
  const [selectedLat, setSelectedLat] = useState()
  const [selectedLng, setSelectedLng] = useState()
  const [isMapError, setIsMapError] = useState(false)
  const [locationName, setLocationName] = useState('')
  const [selectedId, setSelectedId] = useState('')
  const [renderGMap, setRenderGMap] = useState(true)

  useEffect(() => {
    // let progressId = location.search.substring(1)
    let progressId = sessionStorage.getItem('param')?.substring(1)
    // console.log('AreaTableForm', _formSchemas, 'progressId', progressId)
    setProgressId(progressId)
    setFormSchema(_formSchemas)
  }, [_formSchemas])

  useEffect(() => {
    handleLocation()
  }, [])

  useEffect(() => {
    console.log('set marker form values', formSchema.values)
    let arr = formSchema.values
    if (arr.length > 0) {
      let _markers = []
      arr.map((item) => {
        let position = {
          lat: item.latitude,
          lng: item.longitude,
        }
        _markers.push(position)
      })
      setMarkers(_markers)
    } else {
      let position = {
        lat: 0.0,
        lng: 0.0,
      }
      setMarkers([position])
    }
  }, [formSchema])

  const handleLocation = async () => {
    setIsLoading(true)
    const location = await loadLocation()
    setLocationList(location)
    setIsLoading(false)
  }

  const handleSaveProgessActivity = async (request, projectProgressId) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      console.log('call save.')
      const response = await saveProgessActivity(projectId, projectProgressId, request)

      console.log('response', response)

      if (response) {
        // onChangeIsEdit(false)
        let arr = [{ start: '', end: '' }]
        setStartEndList(arr)

        setIsEdit(false)
        setIsAdd(false)
        setFormSchema(response)
        props.onAddSuccess(response)
        // await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleUpdateProgessActivity = async (request, projectProgressId) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      console.log('call update.')
      const response = await updateProgessActivity(projectId, projectProgressId, request)

      console.log('response', response)

      if (response) {
        // onChangeIsEdit(false)
        let arr = [{ start: '', end: '' }]
        setStartEndList(arr)
        setValueID('')
        setIsEdit(false)
        setIsAdd(false)
        setFormSchema(response)
        props.onAddSuccess(response)
        // await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleEdit = (rowData) => {
    setIsEdit(true)
    setSelectedId(rowData.id)
    setValue(formSchema.location.name, rowData.location)
    setValue(formSchema.villageName.name, rowData.villageName)
    setValue(formSchema.locationType.name, rowData.locationType)
    setSelectedLat(rowData.latitude)
    setSelectedLng(rowData.longitude)
    setLocationName(rowData.locationName)
  }

  const handleCancelEdit = () => {
    setIsEdit(false)
    setValue(formSchema.location.name, null)
    setValue(formSchema.villageName.name, null)
    setValue(formSchema.locationType.name, null)
    setSelectedLat(null)
    setSelectedLng(null)
    setLocationName('')
  }

  const handleDelete = (id) => {
    console.log(id)
    let arr = formSchema.values
    arr.forEach((item, index) => {
      if (item.id === id) {
        if (id.indexOf('ADD') != -1) {
          arr.splice(index, 1)
        } else {
          arr[index].isDelete = true
        }
      }
    })
    setFormSchema((state) => ({ ...state, values: arr }))
  }

  const onSubmit = (data) => {
    console.log('data', data)
    setRenderGMap(false)
    if ((selectedLat && selectedLng) || isDep6) {
      setIsMapError(false)

      let date = new Date().getTime()
      let _data = {
        id: isEdit ? selectedId : `ADD_ID_${date}`,
        location: data.location,
        locationName: locationName,
        locationType: data.locationType,
        villageName: data.villageName,
        latitude: selectedLat || 0,
        longitude: selectedLng || 0,
        isDelete: false,
      }

      //handleSaveProgessActivity(data)

      if (isEdit) {
        let arr = formSchema.values
        let editIndex
        arr.forEach((item, index) => {
          if (item.id == _data.id) {
            editIndex = index
          }
        })
        arr.splice(editIndex, 1, _data)
        setFormSchema((state) => ({ ...state, values: arr }))

        setIsEdit(false)
        setSelectedId('')
      } else {
        let arr = formSchema.values
        arr.push(_data)
        setFormSchema((state) => ({ ...state, values: arr }))

        let _markers = markers
        _markers.push({ lat: selectedLat, lng: selectedLng })
        setMarkers(_markers)
      }

      setValue(formSchema.location.name, null)
      setValue(formSchema.villageName.name, null)
      setValue(formSchema.locationType.name, null)
      setSelectedLat(null)
      setSelectedLng(null)
      setLocationName('')
    } else {
      setIsMapError(true)
    }
    setRenderGMap(true)
  }

  const onSelectPlace = (e) => {
    console.log('e', e)
    // let _markers = markers
    // _markers.push(e)
    // setMarkers(_markers)
    // setMarkers(markers=>([...markers,e]))
    setSelectedLat(e.lat)
    setSelectedLng(e.lng)
    setLocationName(e.name)
  }

  const generateTable = (dataList) => {
    if (dataList) {
      let _dataList = dataList.map((item) => {
        let dataTable = item
        let valList = item.location.split('-')
        let dataObj = locationList
        let keyValue = ''
        let province = ''
        let district = ''
        let subDistrict = ''

        for (let index = 0; index < valList.length; index++) {
          if (index === 0) {
            keyValue = valList[index]
          } else {
            keyValue += '-' + valList[index]
          }

          let obj
          dataObj?.forEach((item) => {
            if (item.value === keyValue) {
              obj = item
              return
            }
          })

          if (obj) {
            switch (index) {
              case 0:
                province = obj.label
                break
              case 1:
                district = obj.label
                break
              case 2:
                subDistrict = obj.label
                break
              default:
                break
            }

            dataObj = obj.children
          }
        }

        dataTable.province = province
        dataTable.district = district
        dataTable.subDistrict = subDistrict

        return dataTable
      })
      return _dataList.filter((item) => !item.isDelete)
    }
  }

  return (
    <div
      ref={(section) => {
        setSection(section)
      }}
    >
      <p>พื้นที่ในการดำเนินการ</p>

      {!isDep6 && (
        <>
          {renderGMap && (
            <GMap
              onSelectPlace={onSelectPlace}
              markers={markers}
              singleLat={selectedLat}
              singleLng={selectedLng}
            />
          )}
          {isMapError && (
            <Message showIcon type="error" description={'กรุณาค้นหาสถานที่ บนแผนที่'} />
          )}
        </>
      )}

      <br />
      <Form>
        <FormGroup>
          <Row>
            <Col xs={24} sm={24} md={16} lg={16}>
              <ControlLabel
                className={classNames(isRequired(formSchema.location.validators) && 'required')}
              >
                {formSchema.location.label}
              </ControlLabel>
              {errors.location && (
                <Message showIcon type="error" description={errors.location.message} />
              )}
              <Controller
                name={formSchema.location.name}
                control={control}
                defaultValue={formSchema.location.value}
                rules={isValidators(formSchema.location.validators)}
                render={(props) => {
                  return (
                    <Cascader
                      block
                      menuWidth={180}
                      data={locationList}
                      value={props.value}
                      onChange={(value) => {
                        props.onChange(value)
                      }}
                      placeholder={formSchema.location.label}
                    ></Cascader>
                  )
                }}
              />
            </Col>
            <Col xs={24} sm={24} md={8} lg={8}>
              <ControlLabel
                className={classNames(isRequired(formSchema.villageName.validators) && 'required')}
              >
                {formSchema.villageName.label}
              </ControlLabel>
              {errors.villageName && (
                <Message showIcon type="error" description={errors.villageName.message} />
              )}
              <Input
                placeholder={formSchema.villageName.label}
                defaultValue={formSchema.villageName.value}
                name={formSchema.villageName.name}
                inputRef={register(isValidators(formSchema.villageName.validators))}
              />
            </Col>
          </Row>
        </FormGroup>

        <FormGroup>
          <Row>
            <Col xs={24} sm={24} md={24} lg={24}>
              <ControlLabel
                className={classNames(
                  'style-text-lable',
                  isRequired(formSchema.locationType.validators) && 'required'
                )}
              >
                {formSchema.locationType.label}
              </ControlLabel>
              {errors.locationType && (
                <Message showIcon type="error" description={errors.locationType.message} />
              )}
              <Controller
                name={formSchema.locationType.name}
                control={control}
                defaultValue={formSchema.locationType.value}
                rules={isValidators(formSchema.locationType.validators)}
                render={(props) => {
                  return (
                    <SelectPicker
                      data={formSchema.locationType.options}
                      value={props.value}
                      style={{ width: '100%' }}
                      searchable={true}
                      placeholder="เลือก"
                      onChange={(value) => {
                        props.onChange(value)
                      }}
                    />
                  )
                }}
              />
            </Col>
          </Row>
        </FormGroup>
      </Form>
      <br />
      <Row>
        <IconButton
          appearance="ghost"
          className={isEdit ? 'rs-btn-ghost-edit' : ''}
          icon={
            <Icon
              icon={isEdit ? 'edit' : 'plus'}
              className={isEdit ? 'bt-gost-icon-radius-edit' : 'bt-gost-icon-radius'}
            />
          }
          onClick={handleSubmit(onSubmit)}
        >
          {isEdit ? 'บันทึกการแก้ไข' : 'เพิ่มกลุ่มเป้าหมาย'}
        </IconButton>

        {isEdit && (
          <IconButton
            appearance="ghost"
            className="rs-btn-ghost-cancel"
            icon={<Icon icon={'close'} className="bt-gost-icon-radius-cancel" />}
            onClick={handleCancelEdit}
          >
            {'ยกเลิกการแก้ไข'}
          </IconButton>
        )}
      </Row>

      <br />
      <Table height={400} data={generateTable(formSchema.values)} wordWrap>
        <Column minWidth={100} flexGrow={100}>
          <HeaderCell>{'จังหวัด'}</HeaderCell>
          <Cell dataKey={'province'} />
        </Column>

        <Column minWidth={100} flexGrow={100}>
          <HeaderCell>{'อำเภอ/เขต'}</HeaderCell>
          <Cell dataKey={'district'} />
        </Column>

        <Column minWidth={100} flexGrow={100}>
          <HeaderCell>{'ตำบล/แขวง'}</HeaderCell>
          <Cell dataKey={'subDistrict'} />
        </Column>

        <Column minWidth={100} flexGrow={100}>
          <HeaderCell>{'หมู่บ้าน'}</HeaderCell>
          <Cell dataKey={'villageName'} />
        </Column>

        <Column minWidth={100} flexGrow={100}>
          <HeaderCell>ประเภท</HeaderCell>
          <Cell>
            {(rowData) => {
              const locationType = getValueFromOptions(
                formSchema.locationType.options,
                rowData.locationType
              )
              return <span>{locationType}</span>
            }}
          </Cell>
        </Column>

        <Column width={100} align="center" fixed="right" verticalAlign="middle">
          <HeaderCell></HeaderCell>

          <Cell>
            {(rowData, index) => {
              return (
                <ButtonGroup>
                  <IconButton
                    appearance="ghost"
                    className="rs-btn-ghost-edit"
                    icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                    onClick={(e) => {
                      handleEdit(rowData)
                    }}
                  >
                    แก้ไข
                  </IconButton>
                  <IconButton
                    appearance="ghost"
                    className="rs-btn-ghost-cancel"
                    icon={<Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />}
                    onClick={(e) => {
                      handleDelete(rowData.id, index)
                    }}
                  >
                    ลบ
                  </IconButton>
                </ButtonGroup>
              )
            }}
          </Cell>
        </Column>
      </Table>

      {isLoading && <OverlayLoader />}
    </div>
  )
}
